import { useEffect, useState } from "react";
import img1 from '../assets/images/browse-home/img-1.png'
import img2 from '../assets/images/browse-home/img-2.png'
import img3 from '../assets/images/browse-home/img-3.png'
import img4 from '../assets/images/browse-home/img-4.png'
import img5 from '../assets/images/browse-home/img-5.png'
import img6 from '../assets/images/browse-home/img-6.png'
import img7 from '../assets/images/browse-home/img-7.png'
import { BASE_URL } from '../api/constants'

const useStats = () => {
  const [stats, setStats] = useState([]);
  const [markets, setMarkets] = useState([]);
  const [apartment_cities, setApartmentCities] = useState([]);
  const [new_listings, setListings] = useState([]);


  useEffect(() => {
    const fetchStats = async () => {
      try {
        const url = `${BASE_URL}/properties/stats/browse-home-stats`;
        const res = await fetch(url);
        const data = await res.json();
        if (data?.status && Array.isArray(data.data.stats)) {
          const images = [img1, img2, img3, img4, img5, img5, img6, img7];

          const statsWithImages = data.data.stats.map((home, index) => ({
            ...home,
            img: images[index] || null,
          }));

          setStats(statsWithImages);
        setMarkets(data.data.popular_suburbs)
        setApartmentCities(data.data.popular_cites)
        setListings(data.data.new_county_listings_stats)
        } else {
          setStats([]);
        }
      } catch (err) {
        console.error(err);
        setStats([]);
      }
    };

    fetchStats();
  }, []);

  return { stats, markets, apartment_cities, new_listings };
};


export default useStats;
